import { render, staticRenderFns } from "./kategorie-view.vue?vue&type=template&id=a551e314"
import script from "./kategorie-view.vue?vue&type=script&lang=js"
export * from "./kategorie-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports